import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Button } from 'components/Button';

export const HelpButton = styled.a`
  font: 14px/16px Roboto;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.palette.primary.main};
  padding-bottom: 12px;
  text-decoration: none;
  cursor: pointer;
`;

export const HelpLink = styled(Link)`
  display: flex;
  font: 14px/16px Roboto;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  margin-top: 12px;
`;

export const LoginPageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-image: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.palette.primary.dark},
    ${({ theme }) => theme.palette.primary.main}
  );
`;

export const LoginPageContainer = styled.div`
  border-radius: 16px;
  display: flex;
  padding: 32px;
  justify-content: space-between;
  min-width: 480px;
  max-width: 500px;
  background-color: white;
`;

export const FormContainer = styled.div`
  flex: 1;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  font-style: normal;
  margin-bottom: 24px;
`;

export const InputTitle = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin: 0;
`;

export const EmailTitle = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.17px;
`;

export const InputSubtitle = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: 0.15px;
  white-space: pre-line;
`;

export const StyledButton = styled(Button)`
  border-radius: 10px;
  height: 50px;
  width: 100%;
  font-size: 14px;
  margin-top: 20px;
`;

export const BackButton = styled(Button)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: none;
  background-color: inherit;
  font-size: 14px;
  padding-right: 10px;
`;
